import * as React from 'react';

var _circle, _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCodex = function SvgCodex(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#fff"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M25.326 41.751H11.062v37.43h14.264zM39.59 26.854H25.328V41.75h14.264zM39.59 79.182H25.328v14.897h14.264z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M60.704 11.955c26.222 0 47.478 21.72 47.478 48.51 0 26.792-21.257 48.511-47.478 48.511H39.589V94.078h21.115V26.853H39.589V11.955z"
    })));
};

export { SvgCodex as ReactComponent };
//# sourceMappingURL=Codex.svg.es.js.map
